import React from 'react';
import { Row, Col, Card, Spinner } from 'react-bootstrap';
import { Users, Repeat, Award, DollarSign } from 'lucide-react';

const formatCurrency = (n) =>
  new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND', maximumFractionDigits: 0 }).format(n || 0);

const formatPct = (n) => `${((n || 0) * 100).toFixed(1)}%`;

const SummaryCard = ({ icon: Icon, title, value, subtitle, color = '#0d6efd' }) => (
  <Card className="h-100 shadow-sm">
    <Card.Body>
      <div className="d-flex align-items-start justify-content-between">
        <div>
          <div className="text-muted small text-uppercase fw-semibold">{title}</div>
          <div className="h3 mb-0 mt-1 fw-bold">{value}</div>
          {subtitle && <div className="text-muted small mt-1">{subtitle}</div>}
        </div>
        <div
          className="d-flex align-items-center justify-content-center rounded-circle"
          style={{ width: 48, height: 48, background: `${color}22`, color }}
        >
          <Icon size={24} />
        </div>
      </div>
    </Card.Body>
  </Card>
);

const SummaryRow = ({ data, period, loyalThreshold, label }) => (
  <>
    {label && (
      <div className="text-muted small fw-semibold mb-2">{label}</div>
    )}
    <Row className="g-3 mb-4">
      <Col md={6} lg={3}>
        <SummaryCard
          icon={Users}
          title="Khách unique"
          value={data.total_unique_customers.toLocaleString('vi-VN')}
          subtitle={
            (data.total_qty || 0) > 0
              ? `${(data.total_qty).toLocaleString('vi-VN')} ly nước`
              : period ? `có SĐT trong ${period.from_date} → ${period.to_date}` : undefined
          }
          color="#0d6efd"
        />
      </Col>
      <Col md={6} lg={3}>
        <SummaryCard
          icon={Repeat}
          title="Tỉ lệ mua lại"
          value={formatPct(data.repurchase_rate)}
          subtitle={`${data.repurchasing_customers.toLocaleString('vi-VN')} khách đã mua ≥ 2 lần`}
          color="#198754"
        />
      </Col>
      <Col md={6} lg={3}>
        <SummaryCard
          icon={Award}
          title={`Khách loyal (≥ ${loyalThreshold} lần)`}
          value={data.loyal_customers.toLocaleString('vi-VN')}
          subtitle="dùng làm cơ sở chăm sóc VIP"
          color="#fd7e14"
        />
      </Col>
      <Col md={6} lg={3}>
        <SummaryCard
          icon={DollarSign}
          title="Doanh thu khách loyal"
          value={formatCurrency(data.loyal_revenue)}
          subtitle={
            data.total_revenue > 0
              ? `${formatPct(data.loyal_revenue / data.total_revenue)} tổng doanh thu`
              : 'chưa có dữ liệu'
          }
          color="#6f42c1"
        />
      </Col>
    </Row>
  </>
);

const RepurchaseSummaryCards = ({ summary, loading }) => {
  if (loading || !summary) {
    return (
      <Row className="mb-4">
        <Col className="text-center py-4">
          <Spinner animation="border" size="sm" /> <span className="ms-2">Đang tải tổng quan…</span>
        </Col>
      </Row>
    );
  }

  return (
    <>
      <SummaryRow
        data={summary}
        period={summary.period}
        loyalThreshold={summary.loyal_threshold}
        label="📦 Theo đơn hàng (Order)"
      />
      {summary.item_based && (
        <SummaryRow
          data={summary.item_based}
          loyalThreshold={summary.loyal_threshold}
          label="🧾 Theo món (OrderItem) — chính xác hơn sau gộp đơn"
        />
      )}
    </>
  );
};

export default RepurchaseSummaryCards;
